import { Col, Container, Row, Stack } from 'react-bootstrap'
import { QRCodeSVG } from 'qrcode.react'
import React, { useState } from 'react'
import { ServiceLocation } from '../../models/User'
import { formatPhoneNumber } from 'react-phone-number-input'
import { SelectDropdown } from '../SelectDropdown/SelectDropdown'

export interface ContactCardSelectorProps {
  locations: ServiceLocation[]
}

export const ContactCardSelector: React.FC<ContactCardSelectorProps> = ({ locations }) => {
  const [locationId, setLocationId] = useState(locations[0].id)

  const createContactCardData = () => {
    const {
      displayName,
      locationDetails: { phoneNumber },
    } = locations.find((location) => location.id === locationId) || locations[0]
    return `BEGIN:VCARD\n\
VERSION:4.0\n\
FN:${displayName.includes('Zocks') ? '' : 'Zocks '}${displayName}\n\
TEL;TYPE=WORK,VOICE:${phoneNumber}\n\
END:VCARD`
  }

  return (
    <Container className='contact-card-container zocks-bg-color-gray-100 zocks-border-1.0'>
      <Row className='py-3'>
        <Col>
          <Stack gap={1}>
            <div className='paragraph-small'>Choose your location</div>
            <SelectDropdown
              options={locations.map(({ id, displayName, locationDetails: { phoneNumber } }) => ({
                id,
                label: `${displayName}: ${formatPhoneNumber(phoneNumber)}`,
              }))}
              onOptionSelected={(option) => {
                setLocationId(option.id)
              }}
            />
          </Stack>
        </Col>
      </Row>
      <Row className='text-center'>
        <Col>
          <div>
            <QRCodeSVG value={createContactCardData()} size={200} marginSize={4} bgColor='#f8f9fa' title='Contact card for Zocks phone number' />
          </div>
        </Col>
      </Row>
      <Row className='text-center py-3 label-medium'>
        <Col>
          <div className='paragraph-medium'>Scan the Zocks contact card and save it to your phonebook</div>
        </Col>
      </Row>
    </Container>
  )
}
